var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Autosuggest',{attrs:{"model":_vm.storeNameModel,"suggestions":_vm.filteredOptionsStore,"placeholder":'tên cửa hàng',"state":_vm.validateStore,"disable":_vm.disable,"limit":10},on:{"select":_vm.onSelectedStore,"change":_vm.onInputChangeStore}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }